import { gql } from '@apollo/client'

import { STORE_FRAGMENT } from '../fragments/StoreFragment'

export const UPDATE_STORE = gql`
  mutation UpdateStore($data: UpdateStoreInput!) {
    updateStore(data: $data) {
      ...Store
    }
  }
  ${STORE_FRAGMENT}
`
